/* ==========================================================================
   Silph TCG — page rachat : exemple dans la zone « Liste des cartes ».

   Un client qui découvre la page ne sait pas à quel niveau de détail on
   l'attend. Trois lignes d'exemple, en gris, lui montrent ce qui nous est utile
   — nom, numéro, extension, langue, état — et disparaissent dès qu'il écrit.
   C'est un simple `placeholder`, donc rien n'est jamais envoyé à sa place.

   Pourquoi en JavaScript : le champ appartient à l'application, et son réglage
   « Espace réservé » est une ligne unique — impossible d'y écrire trois lignes.
   Le texte, lui, reste éditable depuis l'éditeur de thème.
   ========================================================================== */

(function () {
  'use strict';

  var bloc = document.querySelector('.silph-rachat__app-form[data-liste-exemple]');
  if (!bloc) return;

  var exemple = bloc.getAttribute('data-liste-exemple');
  if (!exemple) return;

  function poser() {
    var zone = bloc.querySelector('textarea');
    if (!zone) return false;
    if (zone.placeholder !== exemple) zone.placeholder = exemple;
    return true;
  }

  /* Le formulaire est monté par l'application, après ce script — et il peut se
     redessiner ensuite (changement de langue, validation). On pose l'exemple dès
     qu'il apparaît, puis on veille à ce qu'il ne soit pas effacé. */
  var essais = 0;
  var attente = window.setInterval(function () {
    essais += 1;
    if (poser()) {
      window.clearInterval(attente);
      if (window.MutationObserver) {
        new MutationObserver(poser).observe(bloc, { childList: true, subtree: true });
      }
    } else if (essais > 60) {
      window.clearInterval(attente);
    }
  }, 500);
})();
